<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-01-07 17:47:38
 * @FilePath: /wemeet-admin-new/src/views/brand/enterpriseList.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button :icon="Plus" type="primary" @click="addEnter($event)">添加机构信息</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="类目分组">
            <el-select v-model="queryForm.type" placeholder="请选择类目分组" style="width: 240px">
              <el-option v-for="item in typesList" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="机构名称">
            <el-input v-model.trim="queryForm.exhibitorName" clearable placeholder="请输入机构列表名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
      <el-table-column label="序号" type="index" width="50" />
      <el-table-column label="机构信息" prop="exhibitorName" show-overflow-tooltip />
      <el-table-column label="产品数量" prop="exhibitNum" show-overflow-tooltip />
      <el-table-column label="设置类目分组" prop="category" show-overflow-tooltip />
      <el-table-column label="排序值" prop="sort" show-overflow-tooltip />
      <el-table-column label="状态" prop="status" show-overflow-tooltip>
        <template #default="{ row }">
          <el-switch
            v-model="row.status"
            active-text="上线"
            inactive-text="下线"
            size="large"
            @change="shopStatusChange(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" show-overflow-tooltip width="520">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleSetCategoryGroup(row)">设置类目分组</el-button>
          <el-button plain type="info" @click="handleSetSort(row)">设置排序</el-button>
          <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <edit ref="editRef" :group-id="queryForm.groupId" :meeting-code="queryForm.meetingCode" @fetch-data="fetchData" />

    <setCategoryGroup
      ref="setCategoryGroupRef"
      :group-id="queryForm.groupId"
      :meeting-code="queryForm.meetingCode"
      @fetch-data="fetchData"
    />

    <setSort ref="setSortRef" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { queryExhibitorList, setStatus, delMeetingEnterprise } from '@/api/enterPriseApi'
  import { useRoute } from 'vue-router'
  import setCategoryGroup from './components/setCategoryGroup.vue'
  import setSort from './components/setSort.vue'
  import Bus from '@/utils/bus'
  export default defineComponent({
    name: 'Brand',
    components: {
      Edit: defineAsyncComponent(() => import('./components/addEnterpriseInfo.vue')),
      setCategoryGroup,
      setSort,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          pageNum: 1,
          pageSize: 10,
          meetingCode: route.query.meetingCode,
          groupId: route.query.groupId,
          exhibitorName: '',
        },
        activeName: 'first',
        exportPosterRef: null,
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        productUploadRef: null,
        chooseVal: [],
        fullscreenLoading: false,
        dialogVisible: false,
        posterUrl: '',
        checkRow: {},
        typesList: [
          {
            label: '全部',
            value: '',
          },
        ],
        setCategoryGroupRef: null,
        setSortRef: null,
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.exhibitorCode) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await delMeetingEnterprise({
              meetingEnterpriseId: row.id,
            })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.groupId = route.query.groupId
        // state.queryForm.meetingType = route.query.meetingType
        const { data } = await queryExhibitorList(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const shopStatusChange = async (row) => {
        try {
          let obj = {
            status: row.status,
            meetingEnterpriseId: row.id,
          }
          await setStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          console.log(e)
        }

        fetchData()
      }

      onMounted(() => {
        Bus.$on('fetch-data', () => {
          fetchData()
        })
        fetchData()
      })

      const addEnter = () => {
        state.editRef.handleOpen()
      }

      const handleSetCategoryGroup = (row) => {
        state.setCategoryGroupRef.handleOpen(row)
      }

      const handleSetSort = (row) => {
        state.setSortRef.handleOpen(row)
      }

      const handleCopy = () => {
        proxy.$baseConfirm('请确认要复制并生成一个新的机构列表', null, async () => {
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        })
      }
      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        shopStatusChange,
        handleConfig,
        Delete,
        Search,
        Plus,
        addEnter,
        handleCopy,
        handleSetCategoryGroup,
        handleSetSort,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
